import { FormattedMessage } from "react-intl";

// assets
import { IconDashboard, IconDeviceAnalytics } from "@tabler/icons";

const icons = {
  IconDashboard,
  IconDeviceAnalytics,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Martech = {
  id: "Martech",
  title: <FormattedMessage id="Martech" />,
  icon: icons.IconDashboard,
  type: "group",
  children: [
    {
      id: "martech-dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      url: "/martech/dashboard",
      icon: DashboardIcon,
      breadcrumbs: false,
    },
    {
      id: "martech-campaign-manager",
      title: <FormattedMessage id="Ads" />,
      type: "item",
      url: "/martech/campaign-manager",
      icon: AdsIcon,
      breadcrumbs: false,
    },
    {
      id: "martech-rules",
      title: <FormattedMessage id="Automation Rules" />,
      type: "item",
      url: "/martech/automation-rules",
      icon: RulesIcon,
      breadcrumbs: false,
    },
  ],
};

export default Martech;

function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4H22V20H2V4ZM11 16H13V17H11V16ZM16 13H14V17H16V13ZM17 11H19V17H17V11ZM20 6.00002H3.99997V7.99998H20V6.00002ZM11 13.5C11 15.433 9.43297 17 7.49998 17C5.567 17 3.99997 15.433 3.99997 13.5C3.99997 11.567 5.567 10 7.49998 10C9.43297 10 11 11.567 11 13.5ZM8.59091 11.2506C8.2509 11.0856 7.8779 10.9999 7.49998 11V13.5L9.93102 14.0831C10.0639 13.529 10.0035 12.946 9.75979 12.4309C9.51607 11.9157 9.10367 11.4993 8.59091 11.2506Z"
        fill="currentColor"
        fillOpacity="0.38"
      />
    </svg>
  );
}

function AdsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 9V7H20V9H16ZM17.2 16L14 13.6L15.2 12L18.4 14.4L17.2 16ZM15.2 4L14 2.4L17.2 0L18.4 1.6L15.2 4ZM3 15V11H2C1.45 11 0.979333 10.8043 0.588 10.413C0.196667 10.0217 0.000666667 9.55067 0 9V7C0 6.45 0.196 5.97933 0.588 5.588C0.98 5.19667 1.45067 5.00067 2 5H6L11 2V14L6 11H5V15H3ZM12 11.35V4.65C12.45 5.05 12.8127 5.53767 13.088 6.113C13.3633 6.68833 13.5007 7.31733 13.5 8C13.4993 8.68267 13.3617 9.312 13.087 9.888C12.8123 10.464 12.45 10.9513 12 11.35Z"
        fill="currentColor"
      />
    </svg>
  );
}

function RulesIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49006 1.229C9.89256 1.0175 10.6691 0.75 12.0001 0.75C13.3311 0.75 14.1076 1.018 14.5111 1.229C14.8171 1.389 14.9961 1.644 15.0981 1.857C15.2431 2.1595 15.5606 2.842 15.8381 3.5815C16.3757 3.82706 16.8885 4.12358 17.3696 4.467C18.1496 4.337 18.9006 4.272 19.2351 4.2455C19.4701 4.2275 19.7801 4.2555 20.0726 4.4405C20.4576 4.6835 21.0776 5.222 21.7426 6.375C22.4076 7.528 22.5646 8.334 22.5831 8.789C22.5976 9.134 22.4661 9.4165 22.3331 9.6115C21.9792 10.1286 21.6038 10.6307 21.2081 11.1165C21.2638 11.7042 21.2638 12.2958 21.2081 12.8835C21.6038 13.3693 21.9792 13.8714 22.3331 14.3885C22.4666 14.5835 22.5976 14.866 22.5831 15.211C22.5646 15.666 22.4081 16.472 21.7431 17.625C21.0771 18.778 20.4571 19.3165 20.0726 19.56C19.7806 19.745 19.4706 19.7725 19.2351 19.7545C18.6104 19.7067 17.988 19.6328 17.3696 19.533C16.8885 19.8764 16.3757 20.1729 15.8381 20.4185C15.6155 21.0034 15.3686 21.5787 15.0981 22.143C14.9961 22.356 14.8171 22.6105 14.5111 22.771C14.1076 22.9825 13.3311 23.25 12.0001 23.25C10.6691 23.25 9.89256 22.9825 9.48906 22.771C9.18306 22.611 9.00406 22.356 8.90206 22.143C8.75706 21.8405 8.43956 21.158 8.16206 20.4185C7.62444 20.1729 7.1116 19.8764 6.63056 19.533C5.85056 19.663 5.09956 19.728 4.76456 19.7545C4.52956 19.7725 4.21956 19.7445 3.92756 19.5595C3.54256 19.3165 2.92256 18.778 2.25756 17.625C1.59256 16.472 1.43506 15.666 1.41656 15.211C1.40256 14.866 1.53356 14.5835 1.66656 14.3885C2.02044 13.8714 2.39576 13.3693 2.79156 12.8835C2.73578 12.2958 2.73578 11.7042 2.79156 11.1165C2.39576 10.6307 2.02044 10.1286 1.66656 9.6115C1.53356 9.4165 1.40256 9.1345 1.41656 8.789C1.43556 8.334 1.59156 7.528 2.25706 6.375C2.92256 5.222 3.54306 4.6835 3.92756 4.44C4.21956 4.255 4.52956 4.2275 4.76506 4.2455C5.10006 4.2715 5.85006 4.3375 6.63006 4.467C7.11125 4.12355 7.62427 3.82703 8.16206 3.5815C8.38463 2.99663 8.63152 2.42129 8.90206 1.857C9.00406 1.644 9.18306 1.3895 9.48906 1.229M10.6281 8.3955C9.81306 8.08 9.05006 8.572 8.92556 9.437C8.80609 10.2861 8.74744 11.1426 8.75006 12C8.75006 13.039 8.83156 13.905 8.92656 14.563C9.05156 15.428 9.81406 15.92 10.6291 15.605C11.2011 15.3835 11.9721 15.0385 12.9856 14.5C13.9541 13.985 14.7016 13.5295 15.2656 13.1525C16.1446 12.565 16.1446 11.435 15.2656 10.8475C14.7016 10.4705 13.9541 10.015 12.9856 9.5C11.9721 8.9615 11.2011 8.6165 10.6291 8.395"
        fill="currentColor"
      />
    </svg>
  );
}
